import axios from 'axios'
import { LISTAR_FILTROS_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosMdfe(empresaId) {
  const url = `${URL}/emissao-mdfe/opcoes-filtro/${empresaId}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: LISTAR_FILTROS_MDFE,
        payload: response
      })
  );
}
